export function isAlphaPortalPath(path: string) {
  return (
    [
      '/alpha',
      '/portal',
      '/portal/decisions',
      '/portal/home',
      '/portal/board-packs',
      '/portal/budgets',
      '/portal/notices',
      '/portal/consents',
      '/portal/accountant-reviews',
    ].includes(path.replace(/\/$/, '')) ||
    /^\/portal\/(requests|payment-plans)\/[^/]+\/?$/.test(path)
  );
}
